import React, { useState, useEffect } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import styled from 'styled-components'
import { useIntl } from 'react-intl'

interface PhacilPaymentConfirmModalProps {
  open: boolean
  price: number
  confirm: () => void
  cancel: () => void
}

const PhacilPaymentConfirmModal = (props: PhacilPaymentConfirmModalProps) => {
  const [modal, setModal] = useState(false)
  const { formatMessage } = useIntl()
  const f = (id: any) => formatMessage({ id })

  const toggle = () => {
    setModal(!modal)
  }

  useEffect(() => {
    setModal(props.open)
  }, [props.open])

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} backdrop={false}>
        <ModalHeader>{f('phacilPaymentTitle')}</ModalHeader>
        <ModalBody>
          <p>{f('phacilPaymentMessage')}</p>
          <PriceLine>
            <b>{f('phacilPaymentPriceLabel')}</b>
            <PriceValue>{props.price} €</PriceValue>
          </PriceLine>
        </ModalBody>
        <ModalFooter>
          <StyledButton
            color='primary'
            onClick={() => {
              toggle()
              props.confirm()
            }}
          >
            {f('confirm')}
          </StyledButton>
          <Button
            color='secondary'
            onClick={() => {
              toggle()
              props.cancel()
            }}
          >
            {f('cancel')}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

const PriceLine = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: center;
`

const PriceValue = styled.span`
  margin-left: 0.5rem;
  font-size: 1.1rem;
  color: #202855;
  font-weight: bold;
`

const StyledButton = styled(Button)`
  border: solid 1px #ffb064;
  box-shadow: none;
  border-radius: 3px;
  background-image: linear-gradient(to bottom right, #ff625b, #ffb064);
  color: white;
  transform: perspective(1px) translateZ(0);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
`

export default PhacilPaymentConfirmModal
